import { render } from "./MapReport.vue?vue&type=template&id=0b625924"
import script from "./MapReport.vue?vue&type=script&lang=js"
export * from "./MapReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__